<template>
  <Navbar/>
  <router-view/>
</template>

<script>
import Navbar from './components/Navbar.vue'
import { onBeforeMount } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { getAuth, onAuthStateChanged } from 'firebase/auth'
import Home from './views/Home.vue'

export default {
  components: { Navbar },

  setup() {
    onBeforeMount(() => {
      const router = useRouter()
      const route = useRoute()
      const store = useStore()
      const auth = getAuth()
      
      // check if user is authenticated, if so, update state management and redirect autheticated user to main screen of application
      onAuthStateChanged(auth, (user) => {
        if (user) {
          store.dispatch('setCurrentUser', user)
          router.addRoute({ path: '/', name: 'Home', component: Home })
          router.replace('/')
        } else if (route.path != '/login' && route.path != '/signup'){
          store.dispatch('setCurrentUser', null)
          router.replace('/')
        }
      })
    })
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #7f94a2;
}

body {
  margin: 0;
  background: #051622;
  margin-top: 4em;
}
</style>
